import { render, staticRenderFns } from "./SuccessStorie.vue?vue&type=template&id=806e5858&"
import script from "./SuccessStorie.vue?vue&type=script&lang=js&"
export * from "./SuccessStorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports